const performancesHiddenSeatMap = {
  'f71a2b29-dbac-eb11-82e5-a851811d4564': true,
  '17815ffb-b7e0-eb11-830a-ec3bb53768fe': true
}

export const shouldHideSeatMap = (performanceId: string) => {
  return (performancesHiddenSeatMap as any)[performanceId]
}
